import Link from "next/link";
import React, { useState } from "react";
import helper from "../../lib/helper";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import { Button, Modal } from "react-bootstrap";
import _ from "lodash";
import giftcardModel from "../../models/giftcard.model";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// DefaultColumnFilter definition

const Page = function () {
  const [show, setShow] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const router = useRouter();
  const queryParams = router.query;

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const { register, handleSubmit, formState: { errors }, reset } = useForm();



  const {
    data: giftcarddata,
    mutate: reloadPageData,
    isLoading,
  } = useSWR(queryParams || null, () => giftcardModel.list(queryParams));


  const ExportGiftcard = handleSubmit(async (data, event) => {
    const formData = new FormData();

    formData.set("email", data.email);
    formData.set("start_date", helper.date.format(startDate, "DD-MM-YYYY"));
    formData.set("end_date", helper.date.format(endDate, "DD-MM-YYYY"));

    helper.sweetalert.toast(
      `Email will be sent in few minutes to ${data.email}`
    );
    await giftcardModel
      .ExportGiftcard(formData)
      .then((response) => {
        console.log(response?.data?.message)
        helper.sweetalert.toast(response?.data?.message, "success");
        handleCloseModal();
      })
      .catch((error) => {

        helper.sweetalert.toast(error.response?.data?.message, "error");
        _.each(error.response?.data?.errors, function (err, errorKey) {
          setError(errorKey, { type: "required", message: err });
        });
      });
  });

  const columns = [
    {
      Header: "Image",
      className: "col",
      id: "",
      Cell: ({ row }) => {
        const partner = _.get(
          row.original,
          `partner_product.${row.original.product_sku}`,
          {}
        );
        return (
          <img
            src={partner.images?.small}
            height="40px"
            width="50px"
            alt="N/A"
          />
        );
      },
    },
    {
      Header: "Product-name",
      id: "product_name",
      Cell: ({ row }) => {
        const partner_card = _.get(row.original, `partner_card.[0]`, {});
        return (
          <>
            <div>
              <strong>Order Id:</strong>
              {row.original.id || "N/A"}
            </div>
            <div>
              <strong>Productname:</strong>
              {partner_card.productName || "N/A"}
            </div>
            <div>
              <strong>SKU:</strong>
              {row.original.product_sku || "N/A"}
            </div>
          </>
        );
      },
    },
    {
      Header: "Amount",
      accessor: `amount`,
      className: "col",
    },
    {
      Header: "User Details",
      id: "name",
      accessor: (row) => `${row.name} ${row.email} ${row.mobile}`, // Combine fields for filtering
      Cell: ({ row }) => {
        return (
          <div>
            <div>
              <strong>Name:</strong> {row.original.name}
            </div>
            <div>
              <strong>Email:</strong> {row.original.email}
            </div>
            <div>
              <strong>Mobile:</strong> {row.original.mobile}
            </div>
          </div>
        );
      },

      className: "col",
    },

    {
      Header: "Status",
      accessor: "status",
      className: "col",
    },
    {
      Header: "Payment-status",
      className: "col",
      accessor: (row) => `${row.payment_status} ${row.email} ${row.mobile}`, // Combine fields for filtering
      Cell: ({ row }) => {
        return (
          <div>
            <div>
              <strong>Payment Status:</strong> {row.original.payment_status}
            </div>
            <div>
              <strong>Txn Id :</strong> {row.original.razorpay_payment_id || "N/A"}
            </div>
          </div>
        );
      },
    },

    {
      Header: "Payment-text",
      accessor: "payment_text",
      className: "col",
    },

    {
      Header: "Date",
      id: "created_at",
      Cell: ({ row }) => (
        <>
          <div>
            {helper.date.dateOnly(row.original.created_at)}{" "}
            {helper.date.timeOnly(row.original.created_at)}
          </div>
        </>
      ),
    },

    {
      Header: "Action",
      className: "col-auto text-end",
      id: "action",
      Cell: ({ row }) => (
        <div className="btn-group btn-group-sm">
          <button className="btn btn-sm btn-secondary border-none">
            <i className="bi bi-envelope" />
          </button>
          <button
            type="button"
            className="btn btn-sm btn-secondary ms-1 border-0 "
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            title={row.original?.partner_message || "null"}
          >
            <i className="bi bi-info-circle" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Heading title="Giftcard-orders" showLoader={isLoading || showLoader}>
        <Button onClick={() => setShow(true)} className="ms-1 btn btn-sm">
          Export
        </Button>
      </Heading>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Enter Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit} className="form-control">
            <label className="form-label">Email</label>
            <input
              type="email"
              className={`form-control ${errors?.email && "is-invalid"}`}
              {...register("email", {
                required: "Email is required",
              })}
            />
            <div className="invalid-feedback">
              {errors.email && errors.message}
            </div>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label">Start-date</label>
                <DatePicker
                  selected={startDate}
                  className="form-control"
                  dateFormat="dd-MM-YYYY"
                  onChange={(date) => setStartDate(date)}
                  name="start_date"
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">End-date</label>
                <DatePicker
                  selected={endDate}
                  className="form-control"
                  dateFormat="dd-MM-YYYY"
                  onChange={(date) => setEndDate(date)}
                  name="end_date"
                  autoComplete="off"
                />
              </div>
            </div>
            <button
              type="submit"
              className="btn btn-sm btn-primary float-end mt-4"
              onClick={ExportGiftcard}
            >
              Generate report
            </button>
          </form>
        </Modal.Body>
      </Modal>
      <div className="container-fluid">
        <div className="card">
          <div className="card-header">Giftcard-orders List</div>
          <div className="table-responsive">
            <Table
              key="giftcard"
              columns={columns}
              data={giftcarddata?.data || []}
            />
          </div>
          <div className="card-footer table-responsive">
            <Pagination meta={giftcarddata?.meta} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Page;
